import {
  useMutation, UseMutationOptions, UseMutationResult,
} from 'react-query';
import { useTranslation } from 'react-i18next';
import { Dayjs } from 'dayjs';
import {
  appendQueryParamIfNotEmpty, downloadFile, formatDate,
} from '../../../constants/hookConstants';
import closableEnqueueSnackbar from '../../../components/closableEnqueueSnackbar/closableEnqueueSnackbar';
import { TypeOfMutationFunction } from '../../../interfaces/query/queryHook.type';

interface GetExportFormSubmissionsInterface{
    adCode: string,
    status: number | null,
    orderBy: string,
    sortBy: string,
    from: Dayjs | null,
    to: Dayjs | null,
    rows: number,
    page: number,
    fields: any | null,
}

export const useGetExportFormSubmissionsTable = (
  params : GetExportFormSubmissionsInterface,
) => {
  const { t } = useTranslation();

  const queryParams = new URLSearchParams();
  if (params.fields) {
    Object.keys(params.fields).forEach((key) => params.fields[key] && appendQueryParamIfNotEmpty(queryParams, 'fields', key));
  }

  if (params.adCode) appendQueryParamIfNotEmpty(queryParams, 'adCode', params.adCode.trim());
  if (params.status) appendQueryParamIfNotEmpty(queryParams, 'status', params.status);
  if (params.orderBy) appendQueryParamIfNotEmpty(queryParams, 'orderBy', params.orderBy.trim());
  if (params.sortBy) appendQueryParamIfNotEmpty(queryParams, 'sortBy', params.sortBy.trim());

  appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(params.from));
  appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(params.to));
  appendQueryParamIfNotEmpty(queryParams, 'rows', params.rows);
  appendQueryParamIfNotEmpty(queryParams, 'page', params.page);

  const mutationFunction: TypeOfMutationFunction = async (acceptHeader: string) => {
    const url = `form-submission/get-all-by-date?${queryParams}`;
    await downloadFile(url, acceptHeader, t);
  };

  const options: UseMutationOptions<void, unknown, string> = {
    onError: () => {
      closableEnqueueSnackbar(t('somethingWentWrong'), 'error');
    },
  };

  const mutation: UseMutationResult<void, unknown, string> = useMutation(
    mutationFunction,
    options,
  );

  return mutation;
};
